import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IBookmarkRepository } from '../../repositories/interfaces/iBookmarkRepository';
import { IWatchAgainSearchParams } from '../../../entity/interface/iBookmark';

export interface IGetWatchAgainUseCase {
    execute(
        apiKey: string,
        profileName: string,
        token: string,
        identityToken: string,
        searchParams: IWatchAgainSearchParams
    ): Promise<boolean>;
}

export class GetWatchAgainUseCase implements IGetWatchAgainUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getWatchAgain(): IBookmarkRepository {
        return container.resolve<IBookmarkRepository>(DI.REPOSITORIES.IBookmarkRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        profileName: string,
        token: string,
        identityToken: string,
        searchParams: IWatchAgainSearchParams
    ): Promise<any> {
        return await this.getWatchAgain.getWatchAgain(apiKey, profileName, token, identityToken, searchParams);
    }
}
